import { FC } from "react";
import { IconProps } from "./types";

export const SocialLinkedin: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.353 8.87c-1.956 0-2.831 1.074-3.322 1.83v.037h-.024a.258.258 0 0 0 .024-.037V9.13H9.346c.047 1.04 0 11.087 0 11.087h3.685v-6.192c0-.333.024-.66.121-.898.268-.661.875-1.35 1.891-1.35 1.335 0 1.87 1.019 1.87 2.508v5.932h3.684v-6.356c0-3.407-1.82-4.99-4.244-4.99zM5.487 3.783c-1.26 0-2.084.829-2.084 1.917 0 1.063.8 1.916 2.036 1.916h.024c1.286 0 2.085-.853 2.085-1.916-.023-1.088-.8-1.917-2.061-1.917zM3.62 20.217h3.687V9.13H3.62v11.087z"
      fill={fill}
    />
  </svg>
);
